import { Controller } from "stimulus"

export default class extends Controller {
  connect () {
    const element = this.element
    const echarts = window.echarts
    if (!echarts) return

    let payload = {}
    try {
      payload = JSON.parse(element.dataset.chart || "{}")
    } catch (_e) {
      return
    }

    const chart = echarts.getInstanceByDom(element) || echarts.init(element)
    const segmentSeries = (payload.segments || []).map((segment) => ({
      type: "bar",
      stack: "total",
      barWidth: 58,
      data: (segment.values || []).map((value, index) => {
        const labelText = (segment.labels || [])[index]
        return {
          value,
          labelText,
          itemStyle: { color: (segment.colors || [])[index] },
          label: labelText && value > 0 && value < 8
            ? {
                position: "top",
                distance: 2,
                color: (segment.colors || [])[index],
                textBorderColor: "#ffffff",
                textBorderWidth: 2
              }
            : {}
        }
      }),
      label: {
        show: true,
        position: "inside",
        color: "#ffffff",
        fontSize: 15,
        fontWeight: 800,
        formatter: (params) => params.data.labelText || ""
      }
    }))
    const fallbackSeries = [
      {
        type: "bar",
        stack: "total",
        barWidth: 58,
        data: (payload.solids || []).map((value, index) => {
          const rawValue = (payload.values || [])[index] || 0
          return {
            value,
            itemStyle: { color: payload.colors[index] },
            label: rawValue > 0 && rawValue < 8
              ? {
                  position: "top",
                  distance: 2,
                  color: payload.colors[index],
                  textBorderColor: "#ffffff",
                  textBorderWidth: 2
                }
              : {}
          }
        }),
        label: {
          show: true,
          position: "inside",
          color: "#ffffff",
          fontSize: 15,
          fontWeight: 800,
          formatter: (params) => {
            const topValue = (payload.top_values || [])[params.dataIndex]
            return topValue == null ? "" : `${topValue}%`
          }
        }
      },
      {
        type: "bar",
        stack: "total",
        barWidth: 58,
        data: (payload.pales || []).map((value, index) => ({
          value,
          itemStyle: { color: payload.pale_colors[index] }
        })),
        silent: true
      }
    ]

    chart.setOption({
      animation: false,
      grid: { left: 18, right: 18, top: 24, bottom: 52, containLabel: false },
      xAxis: {
        type: "category",
        data: payload.labels || [],
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          color: "#1f2c3f",
          fontSize: 15,
          fontWeight: 700,
          lineHeight: 24,
          interval: 0
        }
      },
      yAxis: {
        type: "value",
        max: 100,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false }
      },
      series: segmentSeries.length ? segmentSeries : fallbackSeries
    })
    chart.resize()
  }

  disconnect () {
    const chart = window.echarts && window.echarts.getInstanceByDom(this.element)
    if (chart) chart.dispose()
  }
}
